package com.jingfangpai.common.data.model

data class NetworkConfig(val host: String = "",val port: Int = 80,val secure: Boolean = false){}
